'use strict';

import {
  addClassToElement,
  removeClassToElement
} from '@jspartials/class-list-utils';

const selector = {
  form: 'order-form',
  resetButton: 'reset-button',
  orderNumber: 'orderNumber',
  email: 'email'
};

const element = {
  form: document.getElementById(selector.form) || null,
  resetButton: document.getElementById(selector.resetButton) || null,
  orderNumber: document.getElementById(selector.orderNumber) || null,
  email: document.getElementById(selector.email) || null
};

function getQueryParam(param) {
  const params = new URLSearchParams(window.location.search);
  return params.get(param);
}

document.addEventListener('DOMContentLoaded', () => {
  const form = element.form;
  const resetButton = element.resetButton;
  const orderFromUrl = getQueryParam('orderNum');

  if (orderFromUrl && element.orderNumber) {
    element.orderNumber.value = orderFromUrl;
  }

  if (resetButton) {
    resetButton.addEventListener('click', () => {
      window.location.href =
        window.location.origin +
        '/on/demandware.store/Sites-HawkersWorldwide-Site/es_ES/Order-ShowTracking';
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      const orderNumberInput = element.orderNumber;
      const emailInput = element.email;
      const orderNumberErrorDiv = document.getElementById('orderNumber-error');
      const emailErrorDiv = document.getElementById('email-error');

      if (orderNumberInput)
        removeClassToElement(orderNumberInput, 'tw-border-state-error');
      if (orderNumberErrorDiv)
        addClassToElement(orderNumberErrorDiv, 'tw-hidden');
      if (emailInput) removeClassToElement(emailInput, 'tw-border-state-error');
      if (emailErrorDiv) addClassToElement(emailErrorDiv, 'tw-hidden');
    });
  }
});
